import { useEffect, useState } from "react";

/**
 * The rendered size of an element, tracked via ResizeObserver.
 *
 * Callback-ref based so it works for elements that mount AFTER the component
 * does — a plot div that only exists once loading finishes is the usual case.
 *
 * Extracted from `HeadcountTrendCard` when the review trend chart became its
 * second consumer; the hand-built SVG charts all need to render 1:1 against
 * whatever panel they are laid out in.
 */
export function useMeasure<T extends HTMLElement>() {
  const [el, setEl] = useState<T | null>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    if (!el) return;
    const observer = new ResizeObserver((entries) => {
      const rect = entries[0]?.contentRect;
      if (rect) setSize({ width: rect.width, height: rect.height });
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [el]);
  return { ref: setEl, size };
}
